export const truncate = (input: string, maxLength: number, useWordBoundary: boolean) => {
	if (!input || input.length <= maxLength) {
		return input;
	}
	const subString = input.substr(0, maxLength - 1);
	return (useWordBoundary ? subString.substr(0, subString.lastIndexOf(" ")) : subString) + "...";
};
